<app-page-header [title]="'Dealerships'" [subtitle]="'Manage dealerships for SampleStudio'"></app-page-header>

<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="dealership_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="dealership_search">Search dealership</label>
        </p-ifta-label>
        <p-button label="Add Dealership" icon="pi pi-plus" (click)="openCreateDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>

    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.dealerships"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>GSSN</th>
                    <th>Country</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dealership>
                <tr>
                    <td>{{ dealership.name }}</td>
                    <td>{{ dealership.gssn }}</td>
                    <td>{{ dealership.country?.name }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View dealership"
                                      tooltipPosition="left"
                                      routerLink="/dealerships/dealership/{{dealership.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit dealership"
                                      tooltipPosition="left"
                                      (click)="editDealership(dealership)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete dealership"
                                      tooltipPosition="left"
                                      (click)="deleteDealership(dealership)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<div class="flex gap-2 mb-6">
    <p-button label="Export Dealerships" icon="pi pi-download" (click)="exportDealerships()"
              severity="secondary"></p-button>
</div>

<!-- Create Dealership Dialog -->
<app-create-dealership-dialog [(visible)]="this.displayCreateDialog"
                              (dealershipCreated)="reloadDealerships()"></app-create-dealership-dialog>

<!-- Update Dealership Dialog -->
<app-update-dealership-dialog [(visible)]="this.displayUpdateDialog" [dealership]="this.selectedDealership"
                              (dealershipUpdated)="reloadDealerships()"></app-update-dealership-dialog>
